import { Heading6, Text } from '@serodigital/ui-components';
import * as React from 'react';
import { Day } from '../../contexts/heatingSchedules';
import { IScheduleArray } from '../../helpers/scheduleHelper';
import { Degree } from '../degree';
import { Days } from './days';

interface IScheduleCardProps extends IScheduleArray {
  onClick?: () => void;
}

export function ScheduleCard({ start, user_time, end, temperature, day, onClick }: IScheduleCardProps) {
  const weekdaysArray = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  return (
    // rome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
    <div
      onClick={onClick}
      data-qa="schedule-card"
      className="flex flex-col rounded-xl border border-grey-neutral bg-grey-background-1  h-[12rem]  w-[18rem] m-8 pl-20 pr-8 pt-20 pb-4 cursor-pointer"
    >
      {!end ? <Text size={'small'}> Hot Water Ready For: </Text> : null}
      {end ? (
        <Heading6 className="m-0 p-0">
          {user_time ? user_time : start} - {end}
        </Heading6>
      ) : (
        <Heading6 className="m-0 p-0">{user_time ? user_time : start}</Heading6>
      )}
      {temperature ? (
        <Text className="flex flex-row mt-1">
          {'Target temp - '}
          <span className="flex flex-row text-[#EB923A]">
            {temperature}
            <Degree height={20} width={15} fill="#EB923A" />
          </span>
        </Text>
      ) : null}
      <div className="flex flex-row flex-wrap mt-16">
        {weekdaysArray.map(key => (
          <Days key={key} dayKey={key} selected={day.includes(key as Day)} />
        ))}
      </div>
    </div>
  );
}
